
import { buildAssetUri } from '~/utils/mixins';
import CloseIcon from '../icons/CloseIcon.vue';
import TruncateParagraph from '../atom/TruncateParagraph.vue';
import { getImageUrl } from '~/utils/behavior/imageUrl';

export default {
  name: 'UIPostGuideCard',
  components: {
    CloseIcon,
    TruncateParagraph,
  },
  mixins: [buildAssetUri],
  props: {
    guide: {
      type: Object,
      required: true,
    },
    showRemoveIcon: {
      type: Boolean,
      default: true,
    },
    cardWidth: {
      type: Number,
      default: 320,
    },
    thumbnailHeight: {
      type: Number,
      default: 160,
    },
    thumbnailFormat: {
      type: String,
      required: true,
    },
  },
  computed: {
    thumbnailUri() {
      const baseUri = this.buildAssetUri(this.guide.thumbnailUri);

      return getImageUrl(baseUri, this.thumbnailFormat);
    },
    readTime() {
      return this.guide.readTime + ' min';
    },
  },
};
